import axios from '@axios'
import useJwt from '@core/auth/jwt/useJwt'
import jwtDefaultConfig from './jwtDefaultConfig'
import router from '@/router'

const { jwt } = useJwt(axios, jwtDefaultConfig, router)
export default jwt
